export default __webpack_public_path__ + "static/media/digistore24_logo.1a4392e6.png";